import { render, staticRenderFns } from "./kchuizong.vue?vue&type=template&id=d825d798"
import script from "./kchuizong.vue?vue&type=script&lang=js"
export * from "./kchuizong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports